import React, { useEffect, useState } from "react";
import AuthService from "../services/auth/auth_service";
import { FaHome, FaUser, FaCalendar } from "react-icons/fa";
import {Tooltip} from "@material-tailwind/react";
import API from "../services/api";
import {
  Button,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Avatar,
  IconButton,
  Typography,
  Card,
} from "@material-tailwind/react";
import ChevronLeftIcon from "@heroicons/react/20/solid/ChevronLeftIcon";
import ChevronRightIcon from "@heroicons/react/20/solid/ChevronRightIcon";
import Pagination from "./Pagination";

import {CircleLoader, ClockLoader} from "react-spinners";
import PopupCart from "../pop up not used/pop-cart";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PopupProduct from "../pop up not used/pop-product";
import {Link, useNavigate} from "react-router-dom";
import {RadioGroup} from "@headlessui/react";



 const product = {
  name: 'Basic Tee 6-Pack',
  price: '$192',
  href: '#',
  breadcrumbs: [
    { id: 1, name: 'Men', href: '#' },
    { id: 2, name: 'Clothing', href: '#' },
  ],
  images: [
    {
      src: 'https://tailwindui.com/img/ecommerce-images/product-page-02-secondary-product-shot.jpg',
      alt: '',
    },
    {
      src: 'https://tailwindui.com/img/ecommerce-images/product-page-02-tertiary-product-shot-01.jpg',
      alt: 'Model wearing plain black basic tee.',
    },
    {
      src: 'https://tailwindui.com/img/ecommerce-images/product-page-02-tertiary-product-shot-02.jpg',
      alt: 'Model wearing plain gray basic tee.',
    },
    {
      src: 'https://tailwindui.com/img/ecommerce-images/product-page-02-featured-product-shot.jpg',
      alt: 'Model wearing plain white basic tee.',
    },
  ],
  colors: [
    { name: 'White', class: 'bg-white', selectedClass: 'ring-gray-400' },
    { name: 'Gray', class: 'bg-gray-200', selectedClass: 'ring-gray-400' },
    { name: 'Black', class: 'bg-gray-900', selectedClass: 'ring-gray-900' },
  ],
  sizes: [
    { name: 'XXS', inStock: false },
    { name: 'XS', inStock: true },
    { name: 'S', inStock: true },
    { name: 'M', inStock: true },
    { name: 'L', inStock: true },
    { name: 'XL', inStock: true },
    { name: '2XL', inStock: true },
    { name: '3XL', inStock: true },
  ],
  description:
    'The Basic Tee 6-Pack allows you to fully express your vibrant personality with three grayscale options. Feeling adventurous? Put on a heather gray tee. Want to be a trendsetter? Try our exclusive colorway: "Black". Need to add an extra pop of color to your outfit? Our white tee has you covered.',
  highlights: [
    'Hand cut and sewn locally',
    'Dyed with our proprietary colors',
    'Pre-washed & pre-shrunk',
    'Ultra-soft 100% cotton',
  ],
  details:
    'The 6-Pack includes two black, two white, and two heather gray Basic Tees. Sign up for our subscription service and be the first to get new, exciting colors, like our upcoming "Charcoal Gray" limited release.',
}
const reviews = { href: '#', average: 4, totalCount: 117 }

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}




export default function Category1({ subCategory0, subCategory, subCategoryId, category, activeTabValue }) {
    const navigate = useNavigate();

 const [loadingPage, setLoadingPage] = useState(true);




 const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [loading3, setLoading3] = useState(false);
    const [products1, setProducts1] = useState([])
    const [products2, setProducts2] = useState([])
       const [products3, setProducts3] = useState([])
     const [productsSpecial, setProductsSpecial] = useState([])
     const [activeTab, setActiveTab] = useState( 'All'); // Set 'All' initially if activeTabValue is 'All'
    const [newActiveTab, setNewActiveTab] = useState( 'All');
     const [subCategoryName, setSubCategoryName] = useState('All');
     const [show, setshow] = useState(true);


const CustomToast = ({ name, price, imageSrc }) => (
  <div className="bg-white p-4 flex items-center space-x-4">
    <div className="w-16 h-16 rounded-full">
      <img src={imageSrc} height={'100%'} alt="Product Image" />
    </div>
    <div className="flex-grow">
      <div style={{width:'100%'}} className="text-gray-700 text-lg font-semibold">
          Umeweka kikamilifu <i className={'text-red-500'}>{name}</i> kwenye kikapu na bei yake ni <i className={'text-green-500'}>{price} Tsh</i>
      </div>
    </div>
  </div>
);


/*   useEffect(() => {

       if (loadingPage){
            window.scrollTo(0, sessionStorage.getItem('scroll'));
       }
    setTimeout(()=>{
         window.scrollTo(0, sessionStorage.getItem('scroll'));
      setTimeout(()=>{
           setLoadingPage(false)
      },2000)
    },2000)
  }, []);*/




  useEffect(() => {

   /* // This effect will run when `category` or `subCategoryName` changes
    console.log("Effect triggered with subCategoryName:", subCategoryName);
    AuthService.loadProductsByCategoryNameAndSubCategoryName(category, subCategoryName)
      .then((response) => {
           const formattedSubCategory = response.data.results.map((product) => ({
          ...product,
          price: product.price.toLocaleString(),
        }));
        setProducts(formattedSubCategory);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });*/





/*setLoadingPage(true)*/


    AuthService.loadProductsByCategoryNameAndSubCategoryNameForPosition(category, subCategoryName, 'one')
      .then((response) => {

            setLoading(true);

           const formattedSubCategory = response.data.results.map((product) => ({
          ...product,
          price: product.price.toLocaleString(),
        }));
        setProducts1(formattedSubCategory);

         const itemCount = response.data.results.length;
    setLastPage(Math.ceil(response.data.count / itemCount)); // Calculate the last page index
    setNext(response.data.next);
    setPrev(response.data.previous);
    setCurrentPage(1);
        setLoading(true);


              setTimeout(() => {
            setLoading(false);
          }, 1000);

      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });


    AuthService.loadProductsByCategoryNameAndSubCategoryNameForPosition(category, subCategoryName, 'two')
      .then((response) => {
           setLoading(true);

           const formattedSubCategory = response.data.results.map((product) => ({
          ...product,
          price: product.price.toLocaleString(),
        }));
        setProducts2(formattedSubCategory);

         const itemCount = response.data.results.length;
    setLastPage2(Math.ceil(response.data.count / itemCount)); // Calculate the last page index
    setNext2(response.data.next);
    setPrev2(response.data.previous);
    setCurrentPage2(1);
        setLoading(true);


              setTimeout(() => {
            setLoading(false);
          }, 1000);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });

    AuthService.loadProductsByCategoryNameAndSubCategoryNameForPosition(category, subCategoryName, 'three')
      .then((response) => {
           setLoading(true);

           const formattedSubCategory = response.data.results.map((product) => ({
          ...product,
          price: product.price.toLocaleString(),
        }));
        setProducts3(formattedSubCategory);

         const itemCount = response.data.results.length;
    setLastPage3(Math.ceil(response.data.count / itemCount)); // Calculate the last page index
    setNext3(response.data.next);
    setPrev3(response.data.previous);
    setCurrentPage3(1);
        setLoading(true);


              setTimeout(() => {
            setLoading(false);
          }, 1000);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading3(false);
      });

    AuthService.loadProductsByCategoryNameAndSubCategoryNameForPosition(category, subCategoryName, 'special')
      .then((response) => {
            setLoading(true);

           const formattedSubCategory = response.data.results.map((product) => ({
          ...product,
          price: product.price.toLocaleString(),
        }));
        setProductsSpecial(formattedSubCategory);
      });


   /* window.scrollTo(0, sessionStorage.getItem('scroll'));
    setLoadingPage(false)*/
  }, [category, subCategoryName]);




  const [next, setNext] = useState(null);
  const [prev, setPrev] = useState(null);
  const [lastPage, setLastPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);


   const showDataByLink = async (page) => {

            setLoading(true);


  if (page < 1 || page > lastPage) return;
  let url = page === currentPage + 1 ? next : prev; // Compare with currentPage + 1
  if (url) {
    url = url.split('api/')[1];
    console.log(url);

    try {
      const response = await API.ax.get(url);
        const formattedSubCategory = response.data.results.map((product) => ({
          ...product,
          price: product.price.toLocaleString(),
        }));
        setProducts1(formattedSubCategory);
     console.log('next', formattedSubCategory)
      setNext(response.data.next);
      setPrev(response.data.previous);
      setCurrentPage(page);
        setTimeout(() => {
            setLoading(false);
          }, 1000);
    } catch (error) {
      // Handle error
    }
  }
};






   const [next2, setNext2] = useState(null);
  const [prev2, setPrev2] = useState(null);
  const [lastPage2, setLastPage2] = useState(1);
  const [currentPage2, setCurrentPage2] = useState(1);


   const showDataByLink2 = async (page) => {

            setLoading2(true);


  if (page < 1 || page > lastPage2) return;
  let url = page === currentPage2 + 1 ? next2 : prev2; // Compare with currentPage + 1
  if (url) {
    url = url.split('api/')[1];
    console.log(url);

    try {
      const response = await API.ax.get(url);
        const formattedSubCategory = response.data.results.map((product) => ({
          ...product,
          price: product.price.toLocaleString(),
        }));
        setProducts2(formattedSubCategory);
     console.log('next', formattedSubCategory)
      setNext2(response.data.next);
      setPrev2(response.data.previous);
      setCurrentPage2(page);
        setTimeout(() => {
            setLoading2(false);
          }, 1000);
    } catch (error) {
      // Handle error
    }
  }
};






   const [next3, setNext3] = useState(null);
  const [prev3, setPrev3] = useState(null);
  const [lastPage3, setLastPage3] = useState(1);
  const [currentPage3, setCurrentPage3] = useState(1);


   const showDataByLink3 = async (page) => {

            setLoading3(true);


  if (page < 1 || page > lastPage3) return;
  let url = page === currentPage3 + 1 ? next3 : prev3; // Compare with currentPage + 1
  if (url) {
    url = url.split('api/')[1];
    console.log(url);

    try {
      const response = await API.ax.get(url);
        const formattedSubCategory = response.data.results.map((product) => ({
          ...product,
          price: product.price.toLocaleString(),
        }));
        setProducts3(formattedSubCategory);
     console.log('next', formattedSubCategory)
      setNext3(response.data.next);
      setPrev3(response.data.previous);
      setCurrentPage3(page);
        setTimeout(() => {
            setLoading3(false);
          }, 1000);
    } catch (error) {
      // Handle error
    }
  }
};






  const handleClick = (name, id) => {
       const scrollPosition = window.scrollY;
    console.log('Scroll Position:', scrollPosition);
    sessionStorage.setItem('scroll', scrollPosition)
    // Update the `subCategoryName` state here
   console.log("Setting subCategoryName to:", name);
     setSubCategoryName(name);
    setActiveTab(name);
    setNewActiveTab(name);
  };


  const setSessionPosition = (name) => {
       const scrollPosition = window.scrollY;
    console.log('Scroll Position:', scrollPosition);
    sessionStorage.setItem('scroll', scrollPosition)

  }


/*
  useEffect(()=>{
       if (activeTabValue == 'All'){
         setNewActiveTab('All');
    }

  })
*/


    const [open, setOpen] = React.useState(false);
  const [isFavorite, setIsFavorite] = React.useState(false);

  const handleOpen = () => setOpen((cur) => !cur);
  const handleIsFavorite = () => setIsFavorite((cur) => !cur);



 const [showModal, setShowModal] = useState(false);
  const [selectedSize, setSelectedSize] = useState(product.sizes[2])
     const [selectedQuantity, setSelectedQuantity] = useState(1);
       const [clickedSize, setClickedSize] = useState('');

  const [price, setPrice] = useState('');
   const [photo, setPhoto] = useState('');
   const [name, setName] = useState('');
  const [size, setSize] = useState([])
   const [color, setColor] = useState([])
     const [productId, setProductId] = useState('')




  const addToCart = (d) => {
        console.log(d)
        setPhoto(d.photo)
      setProductId(d.id)
       const sizesArray = d.size.split(",");
    setSize(sizesArray);
       setColor(d.color)
       setPrice(d.price)
      setName(d.name)
      setShowModal(true)


      }


     const cartToAdd = () => {
       if (!clickedSize) {
     toast.error('Chagua size')
      return;
    }

       const data = {
      appUser: localStorage.getItem('uuid'),
      product: productId,
      selectedSize: clickedSize,
      Qty: 1,
    };

     /* Qty: selectedQuantity,*/
     console.log(data)
    AuthService.cartAddItems(data).then((r=>{
        console.log(r.data)
         setSelectedSize(product.sizes[2]);
        setClickedSize('')

         toast.success(<CustomToast message={'Umefani kiwa kuongeza bidhaa kwenye kikapu chako'} name={name} price={price} imageSrc={photo} />, {
      position: 'top-center',
      autoClose: 5000, // Time in milliseconds to auto-close the notification (3 seconds in this example)
      hideProgressBar: true, // Display a progress bar
      closeOnClick: true, // Close the notification when clicked
      pauseOnHover: true, // Pause the autoClose timer when hovered
      draggable: true,
              progressClassName:'bg-blue-500'})
       /* toast.success('Umefani kiwa kuongeza bidhaa kwenye kikapu chako')*/
       setShowModal(false)
    }))

      }







/*
const previousScrollY = window.scrollY;

// ... Code to navigate to the next page ...

// When returning to the previous page, scroll back to the previous position
window.scrollTo({
  top: previousScrollY
});
*/



 /*const getScrollPosition = () => {
    localStorage.setItem("scrollPosition", window.scrollY.toString());
  };*/

 /*const [scrollPosition, setScrollPosition] = useState(0);

 useEffect(() => {
    return () => {
      setScrollPosition(window.scrollY);
    };
  }, []);

  // Restore scroll scrollPositionposition when the component mounts
  useEffect(() => {
    window.scrollTo(0, );
  }, [scrollPosition]);


*/

   window.history.pushState(null, null, window.location.href);
window.onpopstate = function () {
  // Show an alert when the user clicks the back button
  /*alert("Your click browser back button");*/
setShowModal(false)

}



    return (
   <>
        <ToastContainer />
      {/* {activeTabValue}*/}
       {/* {category}


       {products.map((d,i)=>{

           return(
               <div key={d.id}>
                   <div>
                       {d.name}
                   </div>
               </div>
           )
       })}*/}

 <div id={'top'} style={{marginTop:''}} className="flex items-center justify-center">
       {subCategory0.map((d, i) => {
  const isActive = d.name === newActiveTab; // Assuming activeTab is the currently active tab name

  return (
    <div  key={d.id} className={`border-b ${isActive ? 'border-blue-600' : 'border-gray-200 dark:border-gray-700'}`}>
      <nav
        className="-mb-0.5 flex justify-end space-x-6"
        aria-label="Tabs"
        role="tablist"
      >
        <button
          onClick={() => handleClick(d.name, d.id)}
          type="button"
          className={`
            ${
              isActive
                ? 'font-semibold border-b-2 border-blue-600 text-blue-600'
                : 'text-gray-500 hover:text-blue-600'
            } 
            py-2 px-4 inline-flex items-center gap-2 border-transparent text-sm whitespace-nowrap transition-all duration-300 ease-in-out transform ${
              isActive ? 'scale-105' : ''
            }
          `}
          id={`horizontal-right-alignment-item-${d.id}`}
          data-hs-tab={`#horizontal-right-alignment-${d.id}`}
          aria-controls={`horizontal-right-alignment-${d.id}`}
          role="tab"
        >
          {/* Icon */}
          {isActive ? (
            <span className={`mr-1 text-lg ${d.icon}`} /> // Active icon
          ) : (

            <span className={`mr-1 text-lg   px-4  text-gray-400 hover:text-blue-600 ${d.icon}`} /> // Inactive icon
          )}
          {/* Tab label */}
          {d.name}
        </button>

      </nav>
    </div>
  );
})}
 </div>

       <section>
           <div className="mx-auto container px-6 xl:px-0 py-4">
            <div className="flex flex-col">
               <div className="flex flex-col justify-center">
  <div className="relative">
    {/* Hide the first image on screens smaller than the medium (md) breakpoint*/}
    <img className="hidden md:block w-full" src="https://i.ibb.co/HxXSY0j/jason-wang-Nx-Awry-Abt-Iw-unsplash-1-1.png" alt="sofa" />

     {/*Hide the second image on screens smaller than the medium (md) breakpoint*/}
    <img className="hidden md:w-full" src="https://i.ibb.co/B6qwqPT/jason-wang-Nx-Awry-Abt-Iw-unsplash-1.png" alt="sofa" />

    <div className="absolute md:bottom-8 bottom-4 pr-10 md:pr-0 left-4 md:left-8 flex justify-start items-start">
      <p className="text-3xl hidden md:block md:text-4xl font-semibold leading-9 text-white">Karibu chagua bidhaa</p>
    </div>
  </div>
</div>



{loading ? (
  // If loading, display loading indicator
  <div className="product-card flex justify-center items-center mt-12">
  <ClockLoader color="#3B82F6" loading={loading} size={30} />
</div>

) : (
                <div  className="mt-10 grid lg:grid-cols-2 gap-x-8 gap-y-8 items-center">
                  {/*  {products1.filter((d) => d.position === 'one').map((d,i)=>{
                        return(
                             style={{ height: "400px" }}
                            <div key={d.id} className="group group-hover:bg-opacity-60 transition duration-500 relative bg-gray-50 sm:p-28 py-36 px-10 flex justify-center items-center">
                        <img  style={{ maxWidth: "100%", height: "auto" }} className="group-hover:opacity-60 transition duration-500" src={d.photo} alt="sofa-3" />
                        <div className="absolute sm:top-8 top-4 left-4 sm:left-8 flex justify-start items-start flex-col space-y-2">
                            <div>
                                <p className="group-hover:opacity-60 transition duration-500 text-xl leading-5 text-gray-600">{d.name}</p>
                            </div>
                            <div>
                                <p className="group-hover:opacity-60 transition duration-500 text-xl font-semibold leading-5 text-gray-800">{d.price} Tsh</p>
                            </div>
                        </div>
                        <div className="group-hover:opacity-60 transition duration-500 absolute bottom-8 right-8 flex justify-start items-start flex-row ">
                            <button className="bg-white border rounded-full focus:bg-gray-800 border-gray-600 p-1.5" />
                            <button className="bg-white border rounded-full focus:bg-gray-800 border-gray-600 p-1.5" />
                        </div>
                      <div className="flex flex-row  bottom-8 left-8 absolute opacity-0 group-hover:opacity-100 transition duration-500">
                       <button>
                         <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                           <path
                               d="M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM15 13H13V15C13 15.2652 12.8946 15.5196 12.7071 15.7071C12.5196 15.8946 12.2652 16 12 16C11.7348 16 11.4804 15.8946 11.2929 15.7071C11.1054 15.5196 11 15.2652 11 15V13H9C8.73479 13 8.48043 12.8946 8.2929 12.7071C8.10536 12.5196 8 12.2652 8 12C8 11.7348 8.10536 11.4804 8.2929 11.2929C8.48043 11.1054 8.73479 11 9 11H11V9C11 8.73478 11.1054 8.48043 11.2929 8.29289C11.4804 8.10536 11.7348 8 12 8C12.2652 8 12.5196 8.10536 12.7071 8.29289C12.8946 8.48043 13 8.73478 13 9V11H15C15.2652 11 15.5196 11.1054 15.7071 11.2929C15.8946 11.4804 16 11.7348 16 12C16 12.2652 15.8946 12.5196 15.7071 12.7071C15.5196 12.8946 15.2652 13 15 13Z"
                               fill="#1F2937"
                           />
                         </svg>
                       </button>
                      <button >
                        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5Z" fill="#1F2937" />
                          <path
                              d="M21.8701 11.5C21.2301 10.39 17.7101 4.82001 11.7301 5.00001C6.20007 5.14001 3.00007 10 2.13007 11.5C2.0423 11.652 1.99609 11.8245 1.99609 12C1.99609 12.1755 2.0423 12.348 2.13007 12.5C2.76007 13.59 6.13007 19 12.0201 19H12.2701C17.8001 18.86 21.0101 14 21.8701 12.5C21.9578 12.348 22.004 12.1755 22.004 12C22.004 11.8245 21.9578 11.652 21.8701 11.5ZM12.0001 15.5C11.3078 15.5 10.6311 15.2947 10.0556 14.9102C9.48 14.5256 9.0314 13.9789 8.76649 13.3394C8.50158 12.6999 8.43227 11.9961 8.56732 11.3172C8.70237 10.6383 9.03571 10.0146 9.52519 9.52514C10.0147 9.03565 10.6383 8.70231 11.3173 8.56726C11.9962 8.43221 12.6999 8.50152 13.3395 8.76643C13.979 9.03134 14.5256 9.47994 14.9102 10.0555C15.2948 10.6311 15.5001 11.3078 15.5001 12C15.5001 12.9283 15.1313 13.8185 14.4749 14.4749C13.8186 15.1313 12.9283 15.5 12.0001 15.5Z"
                              fill="#1F2937"
                          />
                        </svg>
                      </button>
                     <button>
                       <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                         <path
                             d="M12 21C11.8684 21.0008 11.7379 20.9755 11.6161 20.9258C11.4943 20.876 11.3834 20.8027 11.29 20.71L3.51999 12.93C2.54536 11.9452 1.99866 10.6156 1.99866 9.23C1.99866 7.84443 2.54536 6.51482 3.51999 5.53C4.50226 4.55051 5.83283 4.00047 7.21999 4.00047C8.60716 4.00047 9.93773 4.55051 10.92 5.53L12 6.61L13.08 5.53C14.0623 4.55051 15.3928 4.00047 16.78 4.00047C18.1672 4.00047 19.4977 4.55051 20.48 5.53C21.4546 6.51482 22.0013 7.84443 22.0013 9.23C22.0013 10.6156 21.4546 11.9452 20.48 12.93L12.71 20.71C12.6166 20.8027 12.5057 20.876 12.3839 20.9258C12.2621 20.9755 12.1316 21.0008 12 21Z"
                             fill="#1F2937"
                         />
                       </svg>
                     </button>
                    </div>

                                <button className="products__button">
        <i className={`bx ${d.position === 'one' ? 'bx-shopping-bag' : 'bx-other-icon'}`}></i>
      </button>
                    </div>
                        )
                    })}*/}



                  {/*  {products1.filter((d) => d.position === 'one').map((d, i) => {
  return (
    <article
      key={d.id}
      className={`products__card one`}
      style={{
        background: `rgba(255, 255, 255, 0.7) url('${d.photo}') center/contain no-repeat`,
        padding: '20px',
        color: '#000',
        backgroundColor: '#ffffff',
      }}
    >
      <img src={''} alt="" className="featured__img mx-auto" style={{ padding: '40px' }} />
      <h3 className="products__price text-gray-600">{d.name}</h3>
      <p className="products__price text-xl font-semibold leading-5 text-gray-800">{d.price} Tsh</p>
      <div className="flex justify-start items-start flex-row">
        <button className="bg-white border rounded-full focus:bg-gray-800 border-gray-600 p-1.5" />
        <button className="bg-white border rounded-full focus:bg-gray-800 border-gray-600 p-1.5" />
      </div>
      <div className="flex flex-row absolute bottom-8 left-8 opacity-0 group-hover:opacity-100 transition duration-500">
        {d.position === 'one' && (
          <button className="products__button">
            <i className="bx bx-shopping-bag"></i>
          </button>
        )}

      </div>
    </article>
  );
})}*/}


{products1.filter((d) => d.position === 'one').map((d, i) => {
  return (
    <article
         onClick={()=>{PopupProduct.show(d);  setSessionPosition()}}
          onContextMenu={(e) => {
                          e.preventDefault(); // Prevent the default context menu
                          return false;
                        }}
        key={d.id} className={`products__card one group`} style={{ padding: '20px', color: '#000', backgroundColor: '#ffffff' }}>
      <div className={'brightness-100 '} style={{ background: `rgba(255, 255, 255, 0.7) url('${d.photo}') center/contain no-repeat`, paddingTop: '40px' }}>
        <img src={''} alt="" className="featured__img  mx-auto" />
      </div>
{/*onClick={()=>{addToCart(d); setSessionPosition()}}*/}
      <button
              className="products__button">
        <i className="bx bx-cart"></i>
      </button>

      <h3 className="products__price text-gray-600">{d.name.split('-')[0]}{/*{d.name}*/}</h3>
      <p  className="products__price text-xl font-semibold leading-5 text-gray-800">{d.price} Tsh</p>
      <div className="flex justify-start items-start flex-row">
        <button className="bg-white border rounded-full focus:bg-gray-800 border-gray-600 p-1.5" />
        <button className="bg-white border rounded-full focus:bg-gray-800 border-gray-600 p-1.5" />
      </div>
      {/* Set opacity to 100 when hovering for small screens (mobile devices) */}
      <div

        className="flex flex-row absolute bottom-0 left-7 opacity-100 sm:opacity-0 transition duration-500 group-hover:opacity-100"
      >



            <button
                onClick={()=>{PopupProduct.show(d); setSessionPosition()}}
               /* onClick={()=>{navigate(`/popup?d=${encodeURIComponent(JSON.stringify(d))}`); setSessionPosition()}}*/
                      className="products__button">
          <i  className="bx bx-show"></i>

        </button>



      </div>
    </article>
  );
})}










                   {/* {products1.filter((d) => d.position === 'one').map((d, i) => {
  return (
    <article
      key={d.id}
      className={`products__card one`}
      style={{
        background: `rgba(255, 255, 255, 0.7) url('${d.photo}') center/contain no-repeat`,
        padding: '20px',
        color: '#000',
        backgroundColor: '#ffffff',
      }}
    >
      <img src={''} alt="" className="featured__img mx-auto" style={{ padding: '40px' }} />
      <h3 className="products__price text-gray-600">{d.name}</h3>
      <p className="products__price text-xl font-semibold leading-5 text-gray-800">{d.price} Tsh</p>
      <div className="flex justify-start items-start flex-row">
        <button className="bg-white border rounded-full focus:bg-gray-800 border-gray-600 p-1.5" />
        <button className="bg-white border rounded-full focus:bg-gray-800 border-gray-600 p-1.5" />
      </div>
      <div className="flex flex-row absolute bottom-8 left-8 opacity-0 group-hover:opacity-100 transition duration-500">
        <button>
          <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
             Add your shopping bag icon here
          </svg>
        </button>
         Add other buttons/icons here as needed
      </div>
    </article>
  );
})}*/}

                </div>

)}



  <Pagination currentPage={currentPage} lastPage={lastPage} showDataByLink={showDataByLink} id={'top'} />

                {/*{subCategory.length > 0 && (
  <div className="flex justify-end items-end mt-12">
    <div className="flex flex-row items-center justify-center space-x-8">
      <button className="text-base leading-none text-gray-800 border-b-2 border-transparent focus:outline-none focus:border-gray-800">
        <p>1</p>
      </button>
      <button className="text-base leading-none text-gray-800 border-b-2 border-transparent focus:outline-none focus:border-gray-800">
        <p>2</p>
      </button>
      <button className="text-base leading-none text-gray-800 border-b-2 border-transparent focus:outline-none focus:border-gray-800">
        <p>3</p>
      </button>
      <button className="flex justify-center items-center">
        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9 6L15 12L9 18"
            stroke="#1F2937"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>
  </div>
)}*/}




            </div>
        </div>

       </section>








        {/*<section className="story section container mt-6">
             {subCategory.filter((d) => d.position === 'special').map((d,i)=>{
                return(
                    <div  key={d.id} className="story__container grid ">
            <div className="story__data ">
              <h2 className="section__title story__section-title">
                Special
              </h2>

              <h1 className="story__title">
                  {d.name} <br/> kwa {d.price}
              </h1>

              <p className="story__description">
                  {d.description}
              </p>

              <a href="#" className="button button--small">Discover</a>
            </div>

            <div className="story__images ">
              <img src={d.photo} alt="" className="story__img"/>
                <div className="story__square"></div>
            </div>
          </div>
                )
            })}
        </section>*/}


         <section className="story section  container ">
  {productsSpecial.some((d) => d.position === 'special') && (
    <div
          onContextMenu={(e) => {
                          e.preventDefault(); // Prevent the default context menu
                          return false;
                        }}
        className="story__container grid">
      <div className="story__data">
        <h2 className="section__title story__section-title">
          Special
        </h2>
        <h1 className="story__title">
          {productsSpecial.find((d) => d.position === 'special').name.split('-')[0]} <br/> kwa {productsSpecial.find((d) => d.position === 'special').price} <span style={{fontSize:'20px', fontWeight:"bold"}} className={'text-green-300'}>Tsh</span>
        </h1>
        <p className="story__description">
          {productsSpecial.find((d) => d.position === 'special').description}
        </p>
        <span
            onClick={()=>{PopupProduct.show(productsSpecial.find((d) => d.position === 'special')); setSessionPosition()}}
            /*onClick={()=>{navigate(`/popup?d=${encodeURIComponent(JSON.stringify(productsSpecial.find((d) => d.position === 'special')))}`); setSessionPosition()}} */
            className="button button--small "><i className='bx bx-money mr-2'></i>
            Nunua
        </span>
         <span
            onClick={()=>{PopupProduct.show(productsSpecial.find((d) => d.position === 'special')); setSessionPosition()}}
             className="button button--small ml-5  cursor-pointer">
             <i className='bx bx-cart mr-2'></i>
             Cart
         </span>



      </div>
      <div className="story__images">
        <img src={productsSpecial.find((d) => d.position === 'special').photo} alt="" className="story__img"/>
        <div className="story__square"></div>
      </div>
    </div>
  )}
</section>






       {loading2 ? (
  // If loading, display loading indicator
  <div className="product-card flex justify-center items-center mt-12">
  <ClockLoader color="#3B82F6"  loading={loading2} size={30} />
</div>

) : (
        <section id={'topt'} className="products section container">

            {/*id="products"*/}

            {/* Conditionally render <h2> and <div className="products__container grid"> */}
{products2.filter((d) => d.position === 'two').length > 0 && (
  <>
    <h2 className="section__title">
      Products_2
    </h2>
    <div className="products__container grid">
      {products2.map((d, i) => {
  return (
    <article
      key={d.id}

       onClick={()=>{PopupProduct.show(d);  setSessionPosition()}}
      /* onClick={()=>{navigate(`/popup?d=${encodeURIComponent(JSON.stringify(d))}`);  handleClick()}}*/
          onContextMenu={(e) => {
                          e.preventDefault(); // Prevent the default context menu
                          return false;
                        }}
      className={`products__card bg-white ${d.position === 'two' ? ' two' : ' three'}`}
      style={{
        padding: '20px',
        color: '#000',
        backgroundColor: '#ffffff', // Set the background color to white
        height: '250px', // Increase the height to 250px or adjust as needed
      }}
    >
      <div
          style={{ background: `rgba(255, 255, 255, 0.7) url('${d.photo}') center/contain no-repeat`, height: '70%', paddingBottom: '20px' }}></div>
      <div className="flex flex-row absolute bottom-8 left-8 opacity-0 group-hover:opacity-100 transition duration-500">
        {d.position === 'two' && (
          <button className="products__button">
            <i className="bx bx-shopping-bag"></i>
          </button>
        )}
      </div>
      <div style={{ height: '30%' }}>
  <div className="w-full overflow-hidden whitespace-nowrap overflow-ellipsis">
    <h3 className="products__price text-gray-500">
      {d.name.split('-')[0].length > 12 ? `${d.name.split('-')[0].slice(0, 12)}...` : d.name.split('-')[0]}
    </h3>
  </div>
  <span className="products__price font-semibold leading-5">{d.price} Tsh</span>
  <button  className="products__button">{/*onClick={(e)=>{addToCart(d); e.stopPropagation()}}*/}
    <i className={`bx ${d.position === 'two' ? 'bx-cart' : 'bx-other-icon'}`}></i>
  </button>
</div>
    </article>
  );
})}


    </div>
  </>
)}

<Pagination currentPage={currentPage2} lastPage={lastPage2} showDataByLink={showDataByLink2} id={'topt'}/>

          {/*<h2 className="section__title">
            Products
          </h2>

          <div className="products__container grid">



              {subCategory.filter((d) => d.position === 'two').map((d, i) => {
                  return (
                    <article
                         key={d.id}
                      className="products__card"
                      style={{
                        background: `rgba(255, 255, 255, 0.7) url('${d.photo}') center/contain no-repeat`,
                        padding: '20px',
                        color: '#000',
                        backgroundColor: '#ffffff',
                      }}
                    >
                      <img src={''} alt="" className="featured__img mx-auto" style={{ padding: '40px' }} />

                      <h3 className="products__price text-gray-500">Hand Begi</h3>
                      <span className="products__price">6,000 Tsh</span>

                      <button className="products__button">
                        <i className='bx bx-shopping-bag'></i>
                      </button>
                    </article>
                  );
                })}
          </div>*/}
        </section>

           )}



             {loading3 ? (
  // If loading, display loading indicator
  <div className="product-card flex justify-center items-center mt-12">
  <ClockLoader color="#3B82F6"  loading={loading3} size={30} />
</div>

) : (
        <section className="new section container" style={{marginBottom:'-60px'}} id="new">
            {/* Conditionally render <h2> and its associated content */}
{products3.filter((d) => d.position === 'three').length > 0 && (
  <>
    <h2 className="section__title mt-5" id="neew">
      Cat Special
    </h2>
    <div className="">
      <div className="mx-auto max-w-7xl sm:px-1 lg:px-8">
    <div className="mx-auto max-w-2xl lg:max-w-none lg:py-2">
      <div className="mt-6 space-y-6 lg:space-y-0 lg:grid lg:grid-cols-3 lg:gap-6">
            {products3.filter((d) => d.position === 'three').map((d) => (
                <div
                     onClick={()=>{PopupProduct.show(d);  setSessionPosition()}}
                   /* onClick={()=>{navigate(`/popup?d=${encodeURIComponent(JSON.stringify(d))}`);  handleClick()}}*/
                   /* to={`/popup/${d}`}>*/
/*  to={`/popup?d=${encodeURIComponent(JSON.stringify(d))}`}*/>
              <div key={d.id}  className="group relative">
                <div className="relative  w-full overflow-hidden rounded-lg bg-white sm:aspect-h-1 sm:aspect-w-2 lg:aspect-h-1 lg:aspect-w-1 lg:group-hover:opacity-75 sm:h-64">

                  <img
                       onContextMenu={(e) => {
                          e.preventDefault(); // Prevent the default context menu
                          return false;
                        }}
                    src={d.photo}
                    alt={''}
                    style={{filter:'brightness(1.1) contrast(1.02) saturate(1.2)'}}
                    className="h-full w-full object-cover object-center  "
                  />
                </div>
                {/*<h3 className="mt-6 text-sm text-gray-500">
                  <a>
                    <span className="absolute inset-0" />
                    {d.name}
                  </a>
                </h3>
                <p className="text-base font-semibold mb-8">price: {d.price} =/Tsh</p>*/}
                <div className="mt-0 text-sm text-gray-500 flex justify-between items-center">
                    <a  className="flex items-center">
                     <span style={{ fontWeight: "bold", textTransform: "capitalize" }} className="mr-2 text-base products__price">{d.name.split('-')[0]}{/*{d.name}*/}</span>
                    </a>
                    <p className=" nav__linkT font-semibold">
                      TZS {d.price}
                    </p>
                  </div>
              </div>
                    </div>




/*
           <div className="">
  <div className="mx-auto max-w-7xl sm:px-1 lg:px-8">
    <div className="mx-auto max-w-2xl lg:max-w-none lg:py-2">
      <div className="mt-6 space-y-6 lg:space-y-0 lg:grid lg:grid-cols-3 lg:gap-6">
        {products3.filter((d) => d.position === 'three').map((d) => (
          <div key={d.id} className="group relative border rounded-lg overflow-hidden shadow-md">
            <div className="relative bg-white group-hover:opacity-75">
              <div className="aspect-w-16 aspect-h-9">
                <img
                  src={d.photo}
                  alt={d.photo}
                  className="object-cover object-center w-full h-64 lg:h-96"
                />
              </div>
            </div>

            <div className="p-4 lg:p-6 xl:p-8">
              <h3 className="text-lg lg:text-xl xl:text-2xl font-semibold text-gray-800">{d.name}</h3>
              <div className="flex flex-col  justify-between mt-2">
                <h3 className="text-gray-500 text-sm lg:text-base xl:text-lg mb-2 lg:mb-0 xl:mb-2">{d.size}</h3>
                <p className="text-gray-700 text-sm lg:text-base xl:text-lg">{d.price} Tsh</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
</div>*/



            ))}
          </div>
        </div>
      </div>
    </div>
  </>
)}

        </section>
                 )}


        <Pagination currentPage={currentPage3} lastPage={lastPage3} showDataByLink={showDataByLink3} id={'neew'} />
        <br/><br/><br/><br/><br/><br/>





        {showModal && (
            <div style={{opacity:1}}  className={`fixed inset-0  flex items-center justify-center z-50`}>
                <div className=" p-4 bg-blue-100 w-80 max-w-full rounded-md shadow-lg">
                    <span onClick={() => {setShowModal(false); setSelectedSize(product.sizes[2]); setClickedSize('')}} style={{float:"right", fontSize:'24px'}} className={'font-bold'}>
                        x
                    </span>
                    <h2 style={{fontSize:'18px'}} className={'text-center products__price text-base font-bold'}>{name}</h2>
                    <div className={'text-center  h-50 w-full  items-center justify-center text-black'}>
                         <center> <img className={'h-64'} src={photo}/></center>
                    </div>
                    <p className={'text-center text-gray-900 nav__linkT'}>You are about to add this item into cart! choose size</p>



                     <RadioGroup value={selectedSize} onChange={setSelectedSize} className="mt-1">
                          <RadioGroup.Label className="sr-only">Choose a size</RadioGroup.Label>
                          <div className="grid grid-cols-4 gap-4 sm:grid-cols-8 lg:grid-cols-4">
                            {size.map((sizeName) => ( // Change from size to sizeName
                              <RadioGroup.Option
                                key={sizeName} // Change from size to sizeName
                                value={sizeName} // Change from size to sizeName
                                // You can handle the availability logic here if needed
                                className={({ active }) =>
                                  classNames(
                                    ' bg-white text-gray-900 shadow-sm',
                                    active ? 'ring-2 ring-indigo-500' : '',
                                    'group relative flex items-center justify-center rounded-md border py-3 px-4 text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 sm:py-6'
                                  )
                                }
                                onClick={()=>setClickedSize(sizeName)}
                              >
                                {({ active, checked }) => (
                                  <div >
                                    <RadioGroup.Label as="span">{sizeName}</RadioGroup.Label>
                                    <span

                                      className={classNames(
                                        active ? 'border' : 'border-2',
                                        checked ? 'border-indigo-500' : 'border-transparent',
                                        'pointer-events-none absolute -inset-px rounded-md'
                                      )}
                                      aria-hidden="true"
                                    />
                                  </div>
                                )}
                              </RadioGroup.Option>
                            ))}
                          </div>
                        </RadioGroup>




                    <div className="mt-4 md:mt-4 w-full flex justify-center">
                        <button  onClick={()=> {cartToAdd()}} className="w-full sm:w-auto border border-gray-800 text-base font-medium text-gray-800 py-5 px-14 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800 bg-gray-800 hover:bg-gray-900 text-white">
                            Weka kwa kikapu
                        </button>
                    </div>
                </div>
            </div>
      )}


      {/*{loadingPage && (
        <div style={{zIndex:500, backgroundColor:"red",position:"fixed", top:0, left:0, bottom:0, right:0}}>
            Loading..
        </div>
    )}
*/}


   </>
  )
}
